module.exports = __webpack_public_path__ + "media/images/banner-f3d0e52db80688859d50e81b62354669.jpeg";